<template>
  <LayoutCard class="title-card">
    <h5 class="title">{{ title }}</h5>
    <slot />
  </LayoutCard>
</template>

<script setup lang="ts">
import LayoutCard from '../layout/LayoutCard.vue'

withDefaults(
  defineProps<{
    title: string
  }>(),
  {
    title: 'Card title'
  }
)
</script>

<style scoped>
.title-card {
  color: rgba(var(--vcrgb-dark), 0.75);
}

.title-card > h5 {
  color: var(--vc-dark);
  margin-bottom: 10px;
}
</style>
